document.addEventListener('DOMContentLoaded', function() {
  var popup = document.getElementById('popup');
  var popupOverlay = document.getElementById('popup-overlay');
  var popupClose = document.getElementById('popup-close');

  // Show the popup after a delay
  setTimeout(function() {
    popup.style.display = 'block';
    popupOverlay.style.display = 'block';
  }, 1000); // 1 second delay

  // Close the popup when the close button is clicked
  popupClose.addEventListener('click', function() {
    popup.style.display = 'none';
    popupOverlay.style.display = 'none';
  });

  // Close the popup when clicking outside of it
  popupOverlay.addEventListener('click', function() {
    popup.style.display = 'none';
    popupOverlay.style.display = 'none';
  });
});
